﻿(function () {
    'use strict';
    var controllerId = 'appmntCtainerEntrySearchController';

    angular
        .module('app.controllers')
        .controller(controllerId, appmntCtainerEntrySearchController);

    appmntCtainerEntrySearchController.$inject = ['$location', 'common', 'datacontext'];

    function appmntCtainerEntrySearchController($location, common, datacontext) {

        init();

        function init() {
            common.activateController([getTest()])
            .then(function () {
                common.logger.debug('------------------------------  ' + controllerId);
            });
        }

        function getTest() {
            return datacontext.security.getTest().then(function (data) {
                return data;
            });
        }

    }

})();